export const getEnvironmentVariable = (name: string) => process.env[name] || '';
